import { useMemo } from "react";
import { useStopwatch, type StopwatchHandle } from "./useStopwatch";
import { useVisibilityChange } from "./useVisibilityChange";

/**
 * Stopwatch that excludes time spent with the tab hidden.
 * Visibility changes are wired to stop/start automatically.
 * reset() pauses immediately when the tab is already hidden so no hidden time leaks in.
 */
export function useForegroundStopwatch(): StopwatchHandle {
  const stopwatch = useStopwatch();

  useVisibilityChange((state) => {
    if (state === "hidden") stopwatch.stop();
    else stopwatch.start();
  });

  return useMemo(
    () => ({
      start: stopwatch.start,
      stop: stopwatch.stop,
      reset() {
        stopwatch.reset();
        if (document.visibilityState === "hidden") stopwatch.stop();
      },
    }),
    [stopwatch]
  );
}
